import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "showUploadProgress", "size", "uploadProgress"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import FormField from 'components/FormField';
import useUniqueId from 'hooks/useUniqueId';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { jsxs as _jsxs } from "react/jsx-runtime";
var FileSizeField = function FileSizeField(_ref) {
  var id = _ref.id,
    showUploadProgress = _ref.showUploadProgress,
    size = _ref.size,
    uploadProgress = _ref.uploadProgress,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId(id);
  var progress = " (".concat(t('form_uploaded_progress', {
    progress: "".concat(Math.ceil(uploadProgress !== null && uploadProgress !== void 0 ? uploadProgress : 0), "%")
  }), ")");
  return /*#__PURE__*/_jsxs(FormField, _objectSpread(_objectSpread({
    label: t('form_file_size_colon'),
    labelId: uniqueId
  }, otherProps), {}, {
    children: [size, showUploadProgress && progress]
  }));
};
export default FileSizeField;